export default __webpack_public_path__ + "static/media/target-club.86657ae2.svg";